export const userDataConstants = {
	USER_DATA_REQUEST: 'USER_DATA_REQUEST',
	USER_DATA_SUCCESS: 'USER_DATA_SUCCESS',
	USER_DATA_ERROR: 'USER_DATA_ERROR',
	LOGOUT: 'LOGOUT'
};
